import { Modal } from "antd";
import { FC } from "react";

import styles from "./index.less";

import Assistant from "../../assets/assistant.png";
import QRCode from "../../assets/qrcode.png";

import { ReactComponent as CloseIcon } from "../../assets/svg/close.svg";
import { ReactComponent as Feature1Icon } from "../../assets/assistant/1.svg";
import { ReactComponent as Feature2Icon } from "../../assets/assistant/2.svg";
import { ReactComponent as Feature3Icon } from "../../assets/assistant/3.svg";

interface ScanToAddAssistantModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * 扫码添加小助手
 * @returns
 */
const ScanToAddAssistantModal: FC<ScanToAddAssistantModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      centered
      width={320}
      onCancel={onClose}
      onClose={onClose}
      footer={null}
      classNames={{
        content: styles["modal-content"],
      }}
      className={styles["scan-to-add-assistant-modal"]}
      closeIcon={<CloseIcon />}
    >
      <div className={styles["header"]}>
        <div className={styles["title"]}>扫码添加小助手</div>
        <div className={styles["subtitle"]}>和我们的 AI 开启对话吧</div>

        <img src={Assistant} alt="assistant" className={styles["role"]} />
      </div>

      <div className={styles["content"]}>
        <img src={QRCode} alt="qrcode" className={styles["qrcode"]} />
        <div className={styles["features"]}>
          <div className={styles["feature"]}>
            <Feature1Icon />
            <div className={styles["feature-title"]}>功能介绍</div>
          </div>

          <div className={styles["feature"]}>
            <Feature2Icon />
            <div className={styles["feature-title"]}>成品机器人体验</div>
          </div>

          <div className={styles["feature"]}>
            <Feature3Icon />
            <div className={styles["feature-title"]}>AI 落地指导</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ScanToAddAssistantModal;
